import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { InsurersProvider } from '../../providers/insurers/insurers';
import { ProgramInsurersAddPage } from '../program-insurers-add/program-insurers-add';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-insurers',
  templateUrl: 'program-insurers.html',
})
export class ProgramInsurersPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  exportjson: any[] = [];
  displayedColumns = ['name', 'address', 'type', 'fax_number', 'phone_number', 'main_contact','actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private insurerProvider: InsurersProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.insurerProvider
      .listInsurers(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((insurers) => {
        //console.log('Pharmacies: ', pharmacies);
        this.exportjson = insurers;
        this.dataSource = new MatTableDataSource(insurers);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave payers view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Payers'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'payers.xlsx'); // initiate a file download in browser
  }

  addeditInsurer(insurer) {
    this.navCtrl.push(ProgramInsurersAddPage, {'insurerdata': insurer});
  }

  deleteInsurer(insurer_id: string)  {
    //console.log('Delete Pharmacy: ', pharmacyId);
    let confirm = this.alertCtrl.create({
      title: "Delete Payer",
      message:
        "Are you sure you would like to delete this payer?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.insurerProvider.deleteInsurer(this.program_id, insurer_id).then(() => {
              //console.log('Successfully deleted the pharmacy');
            })
            .catch((error) => {
              //console.log('Error deleting pharmacy');
            });
          }
        }
      ]
    });
    confirm.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/program-insurers/program-insurers.ts